import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';

import { CONSTANT_VALUES } from '../constants/constant-values';
import { AppService } from '../app.service';
import { HttpInterceptor } from '../shared/index';
import { environment } from '../../environments/environment';
import { Member } from '../member/member';
import { MemberList } from '../member/member-list';
import { CONSTANT_MESSAGES } from '../constants/constants-messages';
import { UtilityFunctions } from '../shared/utility-functions';

@Injectable()
export class OnBoardingService {
    private _appService;
    private utilityFunctions = new UtilityFunctions();
    constructor(private http: HttpInterceptor, private appService: AppService) {
        this._appService = appService;
    }


    /**
     *  upload member from portal 
     * 
     * @param {MemberList} memberObject 
     * @returns 
     * 
     * @memberOf OnBoardingService
     */
    uploadMembers(memberObject: MemberList) {
        try {
            let url = CONSTANT_VALUES.URL_UPLOAD_MEMBER;
            return new Promise((resolve, reject) => {
                this.http.post(url, memberObject).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }

    sendMailToMembers(memberObject: MemberList) {
        try {
            let url = CONSTANT_VALUES.URL_SEND_MAIL;
            return new Promise((resolve, reject) => {
                this.http.post(url, memberObject).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }

    /**
   * upload booking from portal
   * 
   * @param {MemberList} memberObject 
   * @returns 
   * 
   * @memberof OnBoardingService
   */
    uploadBookings(bookingObj) {
        try {
            let url = CONSTANT_VALUES.URL_UPLOAD_BOOKING;
            return new Promise((resolve, reject) => {
                this.http.post(url, bookingObj).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/on-boarding/on-boarding.service.ts